import { useState } from 'react';
import { getApiUrl, getToken, serveFile } from '../../../utils/request';
import { DownloadDialog } from '.';
import React from 'react';

interface UseDownloadDialogOptions {
  url: string;
  method?: 'GET' | 'POST';
  message?: string;
  buttonText?: string;
}

export function useDownloadDialog({
  url,
  method = 'GET',
  message,
  buttonText,
}: UseDownloadDialogOptions) {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
  const [downloading, setDownloading] = useState(false);

  const download = async () => {
    try {
      setDownloading(true);
      const token = getToken();
      const response = await fetch(getApiUrl(url), {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to get download link');
      }

      const data = await response.json();

      if (data.download_url) {
        setDownloadUrl(data.download_url);
      } else {
        throw new Error('No download URL received');
      }
    } catch (error) {
      console.error('Error fetching file:', error);
    } finally {
      setDownloading(false);
    }
  };

  const dialog = downloadUrl ? (
    <DownloadDialog
      downloadUrl={downloadUrl}
      message={message}
      buttonText={buttonText}
      onClose={() => setDownloadUrl(null)}
    />
  ) : null;

  return {
    download,
    downloading,
    dialog,
  };
}
